import client from './client';

/** Every sidebar badge count in one request. `since` limits the rejected-requests count to newer ones. */
export async function fetchBadgeCounts(since) {
  const { data } = await client.get('/badge-counts', { params: { since: since || undefined } });
  return data.data;
}
